<div [ngClass]="{'wrapper':true,'wrapper-locked':disable===true}">
  <div nz-popover [ngClass]="{'locked':disable===true}" [class]="'color-panel ' + classNames" [ngStyle]="style"
       [(nzPopoverVisible)]="visible"
       (nzPopoverVisibleChange)="change($event)"
       nzPopoverTrigger="click"
       [nzPopoverContent]="contentTemplate">
  </div>
</div>
<ng-template #contentTemplate>
  <div class="color-picker-container">
    <color-sketch [color]="color" (onChange)="onColorChange($event)"></color-sketch>
  </div>
</ng-template>
